import { Box, BoxProps, Typography } from '@mui/material'
import React from 'react'
import { AppContext } from '../../../../contexts/AppContext';
import { useStyles } from './styles/index.styles';
import { MenuProps } from '../../../dtos/menuDtos';
import colors from '../../../styles/colors';

type Props = BoxProps & {
    submenuSelected: boolean
    titleSubmenu: string
}

export  function SubmenuItem({
    submenuSelected,
    titleSubmenu,
    ...rest
}: Props) {

    const { state: { menu } } = React.useContext(AppContext);
    

    const classes = useStyles(menu as MenuProps)

  return (
    <Box
        className={classes.submenu}
        sx={{ backgroundColor: submenuSelected ? colors.purpleDarkMedium : 'transparent' }}
        {...rest}
    >
        <Typography
          sx={{
            color: submenuSelected ? colors.white : colors.grayLightest,
            textAlign: 'left',
            my: 0.75,
            fontSize: '0.8125rem',
            fontWeight: submenuSelected ? 600 : 400,
          }}
        >
            {titleSubmenu}
        </Typography>
    </Box>
  )
}
